
/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES
import Http from '../services/Http';

// private sector
let $http;

//public sector
export default class AffiliateRepo {

    static $resource = 'affiliates';

    constructor($auth){
        $http = new Http($auth);
    }

    myStats(){
        return $http.get(AffiliateRepo.$resource + "/stats").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    stats(id){
      return $http.get(AffiliateRepo.$resource + "/" + id + "/stats").then((response) => {
        return Promise.resolve(response);
      }).catch((response) =>{
        return Promise.reject(response);
      });
    }

    reset(id){
        return $http.get(AffiliateRepo.$resource + "/" + id + "/reset").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

}



// WEBPACK FOOTER //
// ./src/repos/AffiliateRepo.js